import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class StatusColaborador extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/StatusColaboradorLookup" {...this.props} />;
  }
}

export default StatusColaborador;
